import { ServicesType } from './types'
import { SAVE_SERVICES } from './actionTypes'
import { ServiceModel } from '../../../types/services/serviceModel'

const initialState: ServiceModel = {
	content: [],
	header: {
		title: '',
		content: '',
		picture: ''
	},
	locale: undefined
}

const services = (
	state: ServiceModel = initialState,
	action: ServicesType
): ServiceModel => {
	switch (action.type) {
		case SAVE_SERVICES: {
			return action.payload || initialState
		}
		default:
			return state
	}
}

export default services
